import React from 'react';

const NotFound = () => (
    <p>Page not found</p>
);
export default NotFound;
